<template>
	<div
		class="grid-content bg-purple shadowlaw mb6 reviewAnalyzeMain-b-table"
	>
		<div class="filter filterReviewAnalyze">
			<el-form
				ref="form"
				:model="form"
				label-width="80px"
				class="clearfix"
			>
				<el-form-item label="任务标题"  v-if="data=='originalText'">
					<el-input v-model.trim="form.title__contains"></el-input>
				</el-form-item>
				<el-form-item label="报告标题"  v-if="data=='report'">
					<el-input v-model.trim="form.title__contains"></el-input>
				</el-form-item>
				<el-form-item label="创建时间">
					<el-date-picker
						v-model="form.time"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						value-format="yyyy-MM-dd"
					></el-date-picker>
				</el-form-item>
				<div class="operation operationReviewDetail fl">
					<a class="new f_transition" @click="searchTable"> 查询 </a>
					<!-- <a class="new f_transition" @click="resetFun">
						重置
					</a> -->
				</div>
			</el-form>
		</div>
		<div class="tableBox tableBoxReviewTaskManage table-th-tac">
         <!-- 左侧 对任务进行表格统计-->
			<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				v-loading="loading"
				border           
            v-if="data=='originalText'"
            key="originalText"
			>
				<el-table-column
					prop="title"
					label="任务标题"
					min-width="34%"
					align="left"
					:show-overflow-tooltip="true"
				>
				<!-- @click="titleFun(scope.row.uuid, scope.row.type)" -->
					<template slot-scope="scope">
						<span>{{ scope.row.title }}</span
						>
					</template>
				</el-table-column>
				<el-table-column
					prop="process"
					label="审查轮数"
					sortable
					min-width="22%"
					:show-overflow-tooltip="true"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="report_sum"
					label="生成报告数"
					sortable
					min-width="22%"
					:show-overflow-tooltip="true"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="advice_sum"
					label="意见总数"
					sortable
					min-width="18%"
					:show-overflow-tooltip="true"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="advice_mod"
					label="建议修改"
					sortable
					min-width="18%"
					:show-overflow-tooltip="true"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="advice_add"
					label="建议增加"
					sortable
					min-width="18%"
					:show-overflow-tooltip="true"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="advice_del"
					label="建议删除"
					sortable
					min-width="18%"
					:show-overflow-tooltip="true"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="advice_re"
					label="依据理由"
					sortable
					min-width="20%"
					:show-overflow-tooltip="true"
					align="center"
				>
				</el-table-column>
			</el-table>
         <!-- 右侧 对报告进行表格统计-->
         <el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				v-loading="loading"
				border           
            v-if="data=='report'"
            key="report"
			>
				<el-table-column
					prop="title"
					label="报告标题"
					min-width="50%"
					align="left"
					:show-overflow-tooltip="true"
				>
				<!-- @click="titleFun(scope.row.uuid, scope.row.type)" -->
					<template slot-scope="scope">
						<span							
							>{{ scope.row.title }}</span
						>
					</template>
				</el-table-column>
				<el-table-column
					prop="advice_sum"
					label="意见总数"
					sortable
					min-width="14%"
					:show-overflow-tooltip="true"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="advice_mod"
					label="建议修改"
					sortable
					min-width="14%"
					:show-overflow-tooltip="true"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="advice_add"
					label="建议增加"
					sortable
					min-width="14%"
					:show-overflow-tooltip="true"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="advice_del"
					label="建议删除"
					sortable
					min-width="14%"
					:show-overflow-tooltip="true"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="advice_re"
					label="依据理由"
					sortable
					min-width="14%"
					:show-overflow-tooltip="true"
					align="center"
				>
				</el-table-column>
			</el-table>
			<div class="page pt15 pb15 clearfix">
				<el-pagination
					@size-change="handleSizeChangeDeclare"
					@current-change="handleCurrentChangeDeclare"
					:current-page.sync="currentPageDeclare"
					:page-size="pageSize"
					background
					layout="total ,prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
export default {
   props:['data'],
	data() {
		return {
          //筛选条件start==
			form: {
				title__contains: "", //标题
				time: [], //时间
         },         
         //筛选条件end==
         
         //表格start==
			loading:false,//加载中
			tableData: [
            {
               title:"标题",
               round:"第二轮",
               report:33,
               opinion:44,
               edit:6,
               add:9,
               del:10,
               ly:9
            },
            {
               title:"标题",
               round:"第二轮",
               report:31,
               opinion:44,
               edit:43,
               add:78,
               del:43,
               ly:32
            },
            {
               title:"标题",
               round:"第二轮",
               report:3,
               opinion:4,
               edit:5,
               add:6,
               del:8,
               ly:43
            },
            {
               title:"标题",
               round:"第二轮",
               report:45,
               opinion:21,
               edit:32,
               add:9,
               del:7,
               ly:21
            },
            {
               title:"标题",
               round:"第二轮",
               report:45,
               opinion:21,
               edit:32,
               add:9,
               del:7,
               ly:21
            },
         ],
			multipleSelection:[],//表格选中数据
			//表格end==

			//分页start==
			currentPageDeclare: 1, //当前页
			total: 0, // 总共条数
			pageSize: 5, //每页的数量
			//分页end==
      };
	},
	created() {
		this.tableFun(1);
	},
	methods: {
       //重置
		resetFun() {
			this.form.title__contains = "";//标题
			this.form.time = []; //时间
			this.tableFun(1);
		},
		//域内检索
		searchTable() {
			this.tableFun(1);
		},
		//获取table中的数据
		tableFun(str) {
			this.loading = true; //加载中显示
			let startTime = "";
			let endTime = "";
			if (this.form.time&&this.form.time.length > 0) {
				startTime = this.form.time[0];
				endTime = this.form.time[1];
			} else {
				startTime = "";
				endTime = "";
			}
			let url="/japi/check/statistics/";//请求的接口
			let params={};//参数
			//对任务进行表格统计
			if(this.data=='originalText'){
				params={
					tag:"task_detail_sta",
					page:str,
					page_num:5,
					create_time__gte:startTime,
					create_time__lte:endTime,
					title__contains:this.form.title__contains
				}
			}
			//对报告进行表格统计
			else if(this.data=='report'){
				params={
					tag:"report_detail_sta",
					page:str,
					page_num:5,
					create_time__gte:startTime,
					create_time__lte:endTime,
					title__contains:this.form.title__contains
				}
			}

			this.axios({
				method:"get",
				url:url,
				params:params
			}).then((res) => {
					if(this.data=='originalText'){
						console.log("对任务进行表格统计数据======");
					}
					else if(this.data=='report'){
						console.log("对报告进行表格统计数据======");
					}

					if (res.data.code == 200) {
						console.log(res);
						//对任务进行表格统计
						if(this.data=='originalText'){
							this.total = res.data.data.task_detail_sta.sum;
							this.tableData = res.data.data.task_detail_sta.res;
						}
						//对报告进行表格统计
						else if(this.data=='report'){
							this.total = res.data.data.report_detail_sta.sum;
							this.tableData = res.data.data.report_detail_sta.res;
						}						
						// this.curUuid=res.data.data.res[0].
						this.loading = false; //加载中隐藏
					}else {
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000,
						});
					}
				});
		},
		//分页
		handleSizeChangeDeclare(size) {
			// console.log(`每页 ${size} 条`);
			this.pageSize = size;
			this.tableFun(this.currentPageDeclare);
		},
		handleCurrentChangeDeclare(currentPage) {
			// console.log(`当前页: ${currentPage}`);
			this.currentPageDeclare = currentPage;
			this.tableFun(this.currentPageDeclare);
		},
   },
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/mixin.scss"; //定义方法
@import "../../../assets/css/recordReviewDetail.scss"; //智能审查详情页样式
</style>